import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import './style.scss';
import { disableAllMenu } from "modules/actions/statusMenu";
import { sendQuality, setRecheckQuality, setQuality, setResponse, } from "modules/actions/quality";
import {
  disabledTabMoveButton,
  disabledTabMoveInput,
  fallbackTabMove,
} from "helper/index";

const Feedback = () => {
  const dispatch = useDispatch();

  const messageId = useSelector((state) => state.quality.messageId);
  const options = useSelector((state) => state.quality.options);
  const selectedMsgId = useSelector((state) => state.quality.selectedMsgId);

  const textRef = useRef();
  const [params, setParams] = useState({
    sel: "",
    text: "",
  });

  const closeModal = () => {
    dispatch(disableAllMenu());
    fallbackTabMove();
    
    // [j] 웹접근성:  의견남기기 레이어 팝업
    const selector = `div[name="${selectedMsgId}"] ._chat_opinion`;
    document.querySelector(selector).focus();
  };

  const checkQuality = (value) => {
    setParams((prevState) => {
      return {
        sel: value,
        text: prevState.text,
      };
    });
  };

  const confirmEvt = () => {
    console.log('confirmEvt params.sel ::: ', params.sel);
    console.log('confirmEvt params.text ::: ', params.text);
    if (params.sel === "" || params.text === "") {
      dispatch(setRecheckQuality());
    } else {
      const payload = {
        message_id: sessionStorage.getItem("message_id"),
        in_type: "quality",
        quality: {
          value: params.sel,
          // ...options[sel - 1],
          comment: textRef.current.value,
        },
      };
      console.log('confirmEvt payload ::: ', payload);
      dispatch(sendQuality(payload));
      fallbackTabMove();
    }
  };

  const setParamsText = () => {
    setParams((prevState) => {
      return {
        sel: prevState.sel,
        text: textRef.current.value,
      };
    });
  };

  useEffect(() => {
    disabledTabMoveButton([
      "ri-close-line feedback",
      "_quality_item",
      "fd_send_btn",
    ]);
    disabledTabMoveInput();
  }, []);

  return (
    <div className="feedback_bg">
      <div className="feedback_area">
        <button
          type="button"
          className="ri-close-line feedback"
          onClick={closeModal}
          aria-label='닫기'
        />
        {/* <div className="fd_icon_area">
          <div className="opnion_icon">
             <ion-icon name="mail-outline" />
            <span>의견남기기</span> 
          </div>
        </div> */}
        <div className="fd_name fd_name_01">사용자 의견 남기기</div>
        {/* <div className="fd_name fd_name_02">사용자 의견</div> */}
        <div className="fd_btn_text">답변이 어땠는지 평가해주세요.</div>
        <div>
          {options.map((i) => {
            const className =
              params.sel === i.value ? "_quality_item _sel" : "_quality_item";
            const title =
              params.sel === i.value ? "선택됨" : "";
            return (
              <button
                type="button"
                key={i.value}
                className={className}
                title={title}
                onClick={() => checkQuality(i.value)}
              >
                {i.message}
              </button>
            );
          })}
        </div>
        <div className="fd_btn_text">답변 관련 의견을 남겨주세요.</div>
        <textarea
          ref={textRef}
          maxLength="300"
          className="feed_input_textarea"
          onChange={setParamsText}
          placeholder="답변에 대한 의견을 자유롭게 남겨주세요."
          aria-label="챗봇 답변에 대한 사용자 의견을 자유롭게 남겨주세요"
          title="챗봇 답변에 대한 사용자 의견을 자유롭게 남겨주세요"
        />
        <p
          className="comment"
          style={{
            display: params.sel === "" || params.text === "" ? "" : "none",
          }}
        >
          <i className="ri-error-warning-line" style={{ marginRight: "4px" }} />
          평가 및 의견 작성 필수
        </p>
        {/* {params.text === "" ? '': <button
          type="button"
          className='fd_send_btn'
          onClick={confirmEvt}
        >
          확인
        </button>} */}
        <button type="button" className="fd_send_btn" onClick={confirmEvt}>
          확인
        </button>
        {/* <button
          type="button"
          className={`fd_send_btn ${params.sel === "" || params.text === "" ? "_inactive" : ""}`}
          onClick={confirmEvt}
        >
          확인
        </button> */}
      </div>
    </div>
  );
};

export default Feedback;
